import React from 'react'

const FreeShipping = (props) => {
    return (
        <div className='free-shipping'>
            <div className='bg'>
                <svg viewBox='0 0 1490 671'>
                    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd' opacity='0.599382267'>
                        <g transform='translate(-194.000000, -2110.000000)' fill='#EFF3F4'>
                            <path d='M1616,2656 C1711.22742,2565.23636 1693.34932,2373.24269 1638,2280 C1544.01264,2121.66681 1249.74338,2117.80777 844,2111 C248,2101 185.194455,2196.24397 196,2422 C211.432953,2744.43465 486,2840 703,2746 C922.356447,2650.97923 1488,2778 1616,2656 Z' />
                        </g>
                    </g>
                </svg>
            </div>
            <div className='content d-flex justify-content-center align-items-center flex-column pt-3 pt-lg-0 pb-4'>
                <div className='mb-3'>
                    <img src='/images/icon-truck.svg' alt='Free shipping' />
                </div>
                <div>
                    <h4 className='m-0 mb-2 bold'>Get mobile faster. FREE delivery.</h4>
                    <p className='m-0'>Order by credit card for quick SIM dispatch by Australia Post Priority Paid.</p>
                </div>
            </div>
        </div>
    )
}

export default FreeShipping



// WEBPACK FOOTER //
// ./resources/js/components/FreeShipping.js